import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image,
  PDFDownloadLink,
} from "@react-pdf/renderer";

const ProluxGeneralProductSpec = ({
  arrangement,
  insulation,
  type,
  airVolumeFlow,
  dimensions,
  internalPressDrop,
  filterCalc,
  supply,
  sound_power_IN_125,
  sound_power_IN_250,
  sound_power_IN_500,
  sound_power_IN_1000,
  sound_power_IN_2000,
  sound_power_IN_4000,
  sound_power_IN_8000,
  sound_power_OUT_125,
  sound_power_OUT_250,
  sound_power_OUT_500,
  sound_power_OUT_1000,
  sound_power_OUT_2000,
  sound_power_OUT_4000,
  sound_power_OUT_8000,
  sound_power_in,
  sound_power_out,
}) => {
  return (
    <View break={!supply}>
      <View
        style={{
          border: "2px solid black",
          fontSize: "8px",
          marginTop: "10px",
          paddingHorizontal: "5px",
        }}
      >
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            borderBottom: "1px solid black",
          }}
        >
          <View style={{ width: "70%", borderRight: "1px solid black" }}>
            <Text>{supply ? "Zuluft" : "Fortluft"}</Text>
          </View>
          <View
            style={{
              width: "28%",
              borderRight: "1px solid black",
              paddingLeft: "2px",
            }}
          >
            <Text>Druckverlust Gerät total {internalPressDrop} Pa</Text>
          </View>
          <View style={{ width: "2%", paddingLeft: "2px" }}>
            <Text>3</Text>
          </View>
        </View>

        <View style={{ display: "flex", flexDirection: "row" }}>
          <View style={{ width: "2%" }}>
            <Text>1</Text>
          </View>
          <View
            style={{
              width: "96%",
              borderLeft: "1px solid black",
              borderRight: "1px solid black",
            }}
          >
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
              }}
            >
              <View
                style={{
                  paddingLeft: "2px",
                  borderRight: "1px solid black",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                }}
              >
                <Text>Geräte Typ</Text>
                <Text>{type}</Text>
              </View>
              <View
                style={{
                  borderRight: "1px solid black",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                }}
              >
                <Text>Qualitätsstufe</Text>
                <Text>A</Text>
              </View>
              <View
                style={{
                  borderRight: "1px solid black",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                }}
              >
                <Text>Pannel</Text>
                <Text>{arrangement}</Text>
              </View>
              <View
                style={{
                  borderRight: "1px solid black",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                }}
              >
                <Text>Isolation</Text>
                <Text>{insulation}</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  // flex: "1",
                }}
              >
                <Text>Anschluss Kanalsystem</Text>
                <Text>{dimensions}</Text>
              </View>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Luftvolumenstrom</Text>
                <Text>{airVolumeFlow}</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "40%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Schallleistungspegel saugseitig 125 - 8000 Hz</Text>
                <Text>
                  {" "}
                  {sound_power_IN_125} {sound_power_IN_250} {sound_power_IN_500}{" "}
                  {sound_power_IN_1000} {sound_power_IN_2000}{" "}
                  {sound_power_IN_4000} {sound_power_IN_8000} dBA
                </Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "40%",
                  // flex: "1",
                }}
              >
                <Text>Total Schallleistungspegel saugseitig</Text>
                <Text>{sound_power_in} dBA</Text>
              </View>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  color: "white",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>-</Text>
                <Text>-</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "40%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Schallleistungspegel druckseitig 125 - 8000 Hz</Text>
                <Text>
                  {" "}
                  {sound_power_OUT_125} {sound_power_OUT_250}{" "}
                  {sound_power_OUT_500} {sound_power_OUT_1000}{" "}
                  {sound_power_OUT_2000} {sound_power_OUT_4000}{" "}
                  {sound_power_OUT_8000} dBA
                </Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "40%",
                  // flex: "1",
                }}
              >
                <Text>Total Schallleistungspegel druckseitig</Text>
                <Text>{sound_power_out} dBA</Text>
              </View>
            </View>
          </View>
          <View style={{ width: "2%", paddingLeft: "2px" }}>
            <Text>/</Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default ProluxGeneralProductSpec;
